import {Subscriber, SubscriberCreate} from '@/types'
import apiClient from '@/utils/axios'
import {AxiosResponse} from 'axios'

interface SubscriberService{
  postSubscription: (formData:SubscriberCreate) => Promise<AxiosResponse<Subscriber>>
}

const subscribe: SubscriberService = {
  async postSubscription(formData: SubscriberCreate): Promise<AxiosResponse<Subscriber>> {
    const response = await apiClient.post('/subscribers', formData)
    return response
  },
}

export {subscribe}
